export const JOB_STATUS_EDITING = "JOB_STATUS_EDITING";
export const JOB_STATUS_UPLOADING = "JOB_STATUS_UPLOADING";
export const JOB_STATUS_STARTED = "JOB_STATUS_STARTED";
export const JOB_STATUS_FINISHED = "JOB_STATUS_FINISHED";
export const JOB_STATUS_SUBMITTED = "JOB_STATUS_SUBMITTED";

export const IMAGE_STATUS_EDITING = "IMAGE_STATUS_EDITING";
export const IMAGE_STATUS_UPLOADED = "IMAGE_STATUS_UPLOADED";
export const IMAGE_STATUS_PROCESSING = "IMAGE_STATUS_PROCESSING";
export const IMAGE_STATUS_FINISHED = "IMAGE_STATUS_FINISHED";